import { withInstall } from '@map-sdk/utils'

import baseMapTitleLayer from './src/index.vue'

export const BaseMapTitleLayer = withInstall(baseMapTitleLayer)
export default BaseMapTitleLayer

export * from './src/config'
